export function firstCharUpper(value = '') {
    return value.slice(0, 1).toUpperCase() + value.slice(1);
}
